module.exports = __webpack_public_path__ + "img/img_userCaseIcon4.647934d8.png";